import { render, staticRenderFns } from "./wechat-analysis.vue?vue&type=template&id=24d801a6&scoped=true&"
import script from "./wechat-analysis.vue?vue&type=script&lang=js&"
export * from "./wechat-analysis.vue?vue&type=script&lang=js&"
import style0 from "./wechat-analysis.vue?vue&type=style&index=0&id=24d801a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d801a6",
  null
  
)

export default component.exports